import arrowIcon from '@raison/static/icons/arrow-right-s-line.svg';
import React, {ComponentProps} from 'react';
import {cn} from '../../Utilities';
import InlineSvg from '../InlineSvg/InlineSvg';
import {IconProp} from '../shared/props';
import {Hint, OptionObject} from './RsnPicker.shared';

export type RsnPickerTriggerProps<T> = {
    option: OptionObject<T>;
} & ComponentProps<'button'>;

export function RsnPickerTrigger<T>({option, disabled, ...props}: RsnPickerTriggerProps<T>) {
    return (
        <button
            type='button'
            className={cn([
                'flex w-full gap-2 rounded-lg border border-solid border-neutral-20 p-3 text-left leading-none',
                'overflow-hidden [box-shadow:0_2px_8px_0_rgba(0,0,0,0.10)]',
                'active:shadow-none',
                'disabled:cursor-not-allowed disabled:bg-neutral-20 disabled:shadow-none',
            ])}
            disabled={disabled}
            {...props}
        >
            {option.icon && <figure className={'size-9 shrink-0'}>{IconProp.render(option.icon)}</figure>}
            <div className={'flex flex-1 shrink flex-col justify-center overflow-hidden'}>
                <div
                    className={
                        'fv-text-xl-regular max-w-full overflow-hidden overflow-ellipsis whitespace-nowrap text-neutral-100'
                    }
                >
                    {option.title}
                </div>
                {option.hint && (
                    <Hint truncate type={option.hintType}>
                        {option.hint}
                    </Hint>
                )}
            </div>
            {!disabled && (
                <div className={'flex h-9 w-5 items-center'}>
                    <InlineSvg src={arrowIcon} className={'text-ink-icon size-5'} />
                </div>
            )}
        </button>
    );
}
